import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import api from "../lib/api";

const Stars = ({ count = 5 }) => (
  <div className="flex gap-0.5 text-[#E05947]">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} size={16} fill={i < count ? "#E05947" : "transparent"} strokeWidth={1.5} />
    ))}
  </div>
);

export default function Reviews() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/reviews").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return null;

  return (
    <section id="reviews" data-testid="reviews-section" className="py-24 sm:py-32 bg-white">
      <div className="container-wide">
        <div className="reveal flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-12">
          <div>
            <div className="eyebrow mb-3">What our guests say</div>
            <h2 className="section-title text-4xl sm:text-5xl lg:text-6xl">Loved on Google</h2>
          </div>
          <div className="flex items-center gap-5 bg-[#FAF4F1] border border-[#F0EAE6] rounded-2xl px-6 py-4">
            <div>
              <div className="font-serif-display text-5xl text-[#5979A9] leading-none" data-testid="reviews-overall-rating">{data.overall_rating}</div>
              <Stars count={5} />
            </div>
            <div className="h-12 w-px bg-[#5979A9]/20" />
            <div>
              <div className="text-2xl font-semibold text-[#2D3748]" data-testid="reviews-total-count">{data.total_reviews}+</div>
              <div className="text-xs uppercase tracking-[0.2em] text-[#5979A9]/70">Google Reviews</div>
            </div>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 reveal" data-testid="reviews-grid">
          {data.reviews.map((r, i) => (
            <article
              key={i}
              data-testid={`review-card-${i}`}
              className="bg-[#FAF4F1] border border-[#F0EAE6] p-7 rounded-2xl flex flex-col gap-4 hover:-translate-y-1 hover:shadow-lg transition-all duration-300"
            >
              <Stars count={r.rating} />
              <p className="text-[#2D3748] leading-relaxed text-[15px]">“{r.text}”</p>
              <div className="mt-auto flex items-center justify-between pt-3 border-t border-[#5979A9]/10">
                <span className="font-semibold text-[#5979A9]">{r.author}</span>
                <span className="text-xs text-[#4A5568]/70">{r.date}</span>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-12 reveal">
          <a
            href={data.google_url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="view-more-reviews-button"
            className="btn-secondary"
          >
            Read More Reviews on Google
          </a>
        </div>
      </div>
    </section>
  );
}
